import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './MainMobile.css';

import agentIcon from '../../assets/agent3.png';
import llmIcon from '../../assets/model_ai.png';
import mcpIcon from '../../assets/mcp.png';
import networkIcon from '../../assets/gateway.png';
import apiIcon from '../../assets/api2.png';
import identityIcon from '../../assets/thumb.png';
import accessIcon from '../../assets/access.png';
import discoveryIcon from '../../assets/magnifyingglass.png';
import chatIcon from '../../assets/chat.png';

import owaspIcon from '../../assets/owasp.png';
import mitreIcon from '../../assets/mitreatlas.png';
import isoIcon from '../../assets/iso42001.png';
import soc2Icon from '../../assets/soc2.png';
import nistIcon from '../../assets/nisrmf.png';

import runtimeImg from '../../assets/home/shield_still.png';
import purpleteamImg from '../../assets/home/purpleshield.png';
import blueShieldImg from '../../assets/blueshield.png';
import redBgImg from '../../assets/red.png';
import redGif from '../../assets/movie/red.gif';
import blueBgImg from '../../assets/blue.png';
import blueGif from '../../assets/movie/blue.gif';
import howBgImg from '../../assets/how_it_works.png';
import howGif from '../../assets/movie/how_it_works.gif';
import workspaceImg from '../../assets/home/workspace_icon.png';
import logoRotate from '../../assets/movie/logo_rotate_large_v2.gif';

import workspaceVisibilityImg from '../../assets/home/workspace_visibility.png';
import aiGovernancePolicyImg from '../../assets/home/ai_governance_policy.png';
import isoChartImg from '../../assets/home/iso_chart.png';
import openclawWarningImg from '../../assets/home/openclaw_warning.png';

import gptIcon from '../../assets/openaicircle_dark.png';
import githubIcon from '../../assets/github.png';
import huggingFaceIcon from '../../assets/huggingfacecircle.png';
import metaIcon from '../../assets/meta.png';
import claudeIcon from '../../assets/anthropic.png';
import geminiIcon from '../../assets/geminicircle.png';
import mistralIcon from '../../assets/mistral.png';
import deepseekIcon from '../../assets/deepseek.png';
import bedrockIcon from '../../assets/bedrock.png';
import copilotIcon from '../../assets/githubcopilot.png';
import aiAppsIcon from '../../assets/aiapps.png';
import databaseBlueIcon from '../../assets/database_blue.png';

const tickerItems = [
  { text: 'Agent', icon: agentIcon, invert: true },
  { text: 'LLM', icon: llmIcon, invert: true },
  { text: 'MCP', icon: mcpIcon, invert: true },
  { text: 'Network', icon: networkIcon, invert: true },
  { text: 'API Security', icon: apiIcon, invert: true, small: true },
  { text: 'Identity', icon: identityIcon, invert: true },
  { text: 'Access', icon: accessIcon },
  { text: 'Discovery', icon: discoveryIcon, invert: true },
  { text: 'ChatBot', icon: chatIcon, invert: true },
];

const MainMobile = () => {
  const logoRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      if (logoRef.current) {
        const src = logoRef.current.src;
        logoRef.current.src = '';
        logoRef.current.src = src;
      }
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* ─── HERO ─── */}
      <section className="main-hero m-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <div className="m-hero-inner">
          <div className="hero-pre-title">Agentic AI Security Platform</div>
          <div className="hero-sub-title">Unifying Offensive and Defensive<br />AI Security</div>
          <p className="hero-description m-hero-desc">Bltz AI unifies visibility, prevention, detection, and automated remediation, closing the loop on AI risk.</p>
          <button className="hero-demo-btn hero-demo-btn-inline m-hero-demo-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
            Get a Live Demo
            <span className="hero-demo-arrow">→</span>
          </button>

          <div className="m-hero-video-thumb" onClick={() => window.open('https://www.youtube.com/watch?v=jDoTa0Hbu_w', '_blank', 'noopener,noreferrer')}>
            <img ref={logoRef} src={logoRotate} alt="Watch intro video" className="hero-video-thumb-logo" />
            <div className="hero-video-thumb-bottom">
              <div className="hero-video-play">
                <svg viewBox="0 0 24 24" fill="#ffffff" width="14" height="14"><polygon points="7,4 19,12 7,20" /></svg>
              </div>
              <span className="hero-video-thumb-label">See Bltz in Action</span>
            </div>
          </div>

          <div className="m-hero-glass-cards">
            <div className="m-hero-glass-card" onClick={() => document.getElementById('runtime-shield').scrollIntoView({ behavior: 'smooth' })}>
              <img src={runtimeImg} alt="Runtime Shield" className="hero-glass-card-img" />
              <div className="hero-glass-card-text">
                <span className="hero-glass-card-link">Runtime Shield <svg width="10" height="12" viewBox="0 0 10 12" style={{marginLeft: '4px', verticalAlign: 'middle'}}><polygon points="0,0 10,6 0,12" fill="rgba(180,140,255,0.9)" /></svg></span>
                <span className="hero-glass-card-title">Runtime AI Visibility & Protection</span>
              </div>
            </div>
            <div className="m-hero-glass-card" onClick={() => {
              const el = document.querySelector('.m-section-dark');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}>
              <img src={purpleteamImg} alt="Purple Team" className="hero-glass-card-img" />
              <div className="hero-glass-card-text">
                <span className="hero-glass-card-link">Purple Team <svg width="10" height="12" viewBox="0 0 10 12" style={{marginLeft: '4px', verticalAlign: 'middle'}}><polygon points="0,0 10,6 0,12" fill="rgba(180,140,255,0.9)" /></svg></span>
                <span className="hero-glass-card-title">Agentic Red & Blue Teaming, Automated</span>
              </div>
            </div>
            <div className="m-hero-glass-card" onClick={() => {
              const el = document.getElementById('workspace');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}>
              <img src={workspaceImg} alt="Workspace" className="hero-glass-card-img" />
              <div className="hero-glass-card-text">
                <span className="hero-glass-card-link">AI Workspace <svg width="10" height="12" viewBox="0 0 10 12" style={{marginLeft: '4px', verticalAlign: 'middle'}}><polygon points="0,0 10,6 0,12" fill="rgba(180,140,255,0.9)" /></svg></span>
                <span className="hero-glass-card-title">Automated AI Governance & Control</span>
              </div>
            </div>
          </div>
        </div>

        <div className="m-compliance-icons">
          <img src={owaspIcon} alt="OWASP" className="compliance-icon" />
          <img src={mitreIcon} alt="MITRE" className="compliance-icon" />
          <img src={isoIcon} alt="ISO" className="compliance-icon" />
          <img src={soc2Icon} alt="SOC2" className="compliance-icon grayscale" />
          <img src={nistIcon} alt="NIST" className="compliance-icon" />
        </div>
        <p className="compliance-subtitle m-compliance-subtitle">Supports above industry framework reporting</p>
      </section>



      {/* ─── RUNTIME SHIELD ─── */}
      <section className="section-white m-section-white">
        <div className="ticker-container">
          <div className="ticker-track">
            {[...tickerItems, ...tickerItems, ...tickerItems].map((item, index) => (
              <div key={index} className="ticker-item">
                {item.icon && <img src={item.icon} alt={item.text} className={`ticker-icon ${item.invert ? 'invert' : ''} ${item.small ? 'small' : ''}`} />}
                <span className="ticker-text">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <h2 id="runtime-shield" className="section-title m-section-title">Runtime Visibility and Protection</h2>
        <p className="section-description m-section-description">Bltz enables complete visibility and protection for AI in production, discovering and monitoring all AI traffic at runtime while stopping prompt attacks, data leaks, and unsafe behavior.</p>
        <button className="section-learn-more-btn" onClick={() => navigate('/runtime-shield')}>Learn More</button>

        {/* Mobile Gateway Infographic — simplified vertical */}
        <div className="m-gw-infographic">
          <div className="m-gw-headers">
            <div className="m-gw-header-box">One-Stop Integration</div>
            <div className="m-gw-header-box">Discover Shadow AI</div>
            <div className="m-gw-header-box">Prevent Unauthorized Access</div>
            <div className="m-gw-header-box">Detect & Remediate Data Loss</div>
          </div>

          {/* Sources */}
          <div className="m-gw-sources">
            <div className="m-gw-source"><img src={chatIcon} alt="AI CRAWLs" className="gw-source-icon invert" /><span>AI CRAWLs</span></div>
            <div className="m-gw-source"><img src={mcpIcon} alt="MCP Client" className="gw-source-icon invert" /><span>MCP Client</span></div>
            <div className="m-gw-source"><img src={llmIcon} alt="LLMs" className="gw-source-icon invert" /><span>LLMs</span></div>
            <div className="m-gw-source"><img src={agentIcon} alt="AI Agents" className="gw-source-icon invert" /><span>AI Agents</span></div>
            <div className="m-gw-source"><img src={aiAppsIcon} alt="AI Apps" className="gw-source-icon invert" /><span>AI Apps</span></div>
            <div className="m-gw-source"><img src={apiIcon} alt="APIs" className="gw-source-icon invert" /><span>APIs</span></div>
          </div>

          {/* Gateway Card */}
          <div className="m-gw-center">
            <div className="m-gw-gateway-card">
              <img src={runtimeImg} alt="Shield" className="m-gw-shield-icon" />
              <h3 className="gw-gateway-title">Runtime Shield Gateway</h3>
              <div className="m-gw-features">
                <div className="m-gw-feature" onClick={() => navigate('/runtime-shield')}>
                  <span className="m-gw-feature-label">Visibility</span>
                  <p className="m-gw-feature-desc">Discover and monitor all AI traffic across your network in real time.</p>
                </div>
                <div className="m-gw-feature" onClick={() => navigate('/runtime-shield')}>
                  <span className="m-gw-feature-label">Prevention</span>
                  <p className="m-gw-feature-desc">Block prompt attacks, unauthorized access, and data exfiltration automatically.</p>
                </div>
                <div className="m-gw-feature" onClick={() => navigate('/runtime-shield')}>
                  <span className="m-gw-feature-label">Remediation</span>
                  <p className="m-gw-feature-desc">Self-healing response with automated governance and policy enforcement.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Destinations */}
          <div className="m-gw-destinations">
            <div className="m-gw-dest-section">
              <span className="gw-dest-title">Frontier Models</span>
              <div className="m-gw-dest-icons">
                <img src={gptIcon} alt="OpenAI" className="gw-dest-icon invert" />
                <img src={claudeIcon} alt="Claude" className="gw-dest-icon" />
                <img src={geminiIcon} alt="Gemini" className="gw-dest-icon" />
                <img src={deepseekIcon} alt="DeepSeek" className="gw-dest-icon" />
                <img src={metaIcon} alt="Meta" className="gw-dest-icon" />
                <img src={huggingFaceIcon} alt="HuggingFace" className="gw-dest-icon" />
                <img src={mistralIcon} alt="Mistral" className="gw-dest-icon" />
              </div>
            </div>
            <div className="m-gw-dest-section">
              <span className="gw-dest-title">Dev Tools</span>
              <div className="m-gw-dest-icons">
                <div className="gw-dest-labeled-icon"><img src={bedrockIcon} alt="Bedrock" className="gw-dest-icon" /><span>Bedrock</span></div>
                <div className="gw-dest-labeled-icon"><img src={copilotIcon} alt="Code Writer" className="gw-dest-icon invert" /><span>Code Writer</span></div>
                <div className="gw-dest-labeled-icon"><img src={databaseBlueIcon} alt="RAG DB" className="gw-dest-icon" /><span>RAG DB</span></div>
              </div>
            </div>
          </div>
        </div>
        <a href="/runtime-shield" className="section-cta-link" onClick={(e) => { e.preventDefault(); navigate('/runtime-shield'); }}>Also See Runtime Shield API in Action ›</a>
      </section>

      {/* ─── PURPLE TEAM ─── */}
      <section className="section-dark m-section-dark">
        <div className="m-section-dark-product">
          <img src={purpleteamImg} alt="Purple Shield" className="section-dark-shield" />
          <span className="section-dark-label">Bltz Purple Team</span>
        </div>
        <h2 className="section-dark-title m-dark-title">Don't Stop At Red Team, Remediate with Purple Team</h2>
        <p className="section-dark-desc m-dark-desc">Bltz Purple Team provides continuous, agentic AI risk testing and remediation, combining offensive (red team) and defensive (blue team) AI agents.</p>

        <button className="section-learn-more-btn" onClick={() => { navigate('/purple-team'); window.scrollTo(0, 0); }}>Learn More</button>

        <div className="m-pt-cards">
          <div className="m-pt-card" onClick={() => navigate('/purple-team#section-red-team')}>
            <img src={redBgImg} alt="" className="pt-card-still" />
            <img src={redGif} alt="" className="pt-card-gif" />
            <div className="pt-card-content">
              <h3 className="pt-card-label">Agentic Red Teaming</h3>
              <h4 className="pt-card-title">Relentless Attacker Agent Finding Domain Specific Vulnerabilities in Your AI Systems</h4>
              <button className="pt-card-btn m-pt-card-btn" onClick={() => navigate('/purple-team#section-red-team')}>Learn More &rarr;</button>
            </div>
          </div>
          <div className="m-pt-card" onClick={() => navigate('/purple-team#section-blue-team')}>
            <img src={blueBgImg} alt="" className="pt-card-still" />
            <img src={blueGif} alt="" className="pt-card-gif" />
            <div className="pt-card-content">
              <h3 className="pt-card-label">Agentic Blue Teaming</h3>
              <h4 className="pt-card-title">Self-Learning Defender Agent Mitigating Threats in Real Time</h4>
              <button className="pt-card-btn m-pt-card-btn" onClick={() => navigate('/purple-team#section-blue-team')}>Learn More &rarr;</button>
            </div>
          </div>
          <div className="m-pt-card" onClick={() => navigate('/purple-team#section-how-it-works')}>
            <img src={howBgImg} alt="" className="pt-card-still" />
            <img src={howGif} alt="" className="pt-card-gif" />
            <div className="pt-card-content">
              <h3 className="pt-card-label">Why Defensive AI Security?</h3>
              <h4 className="pt-card-title">See how with right agentic strategies, you can protect your AI systems effectively</h4>
              <button className="pt-card-btn m-pt-card-btn" onClick={() => navigate('/purple-team#section-how-it-works')}>Learn More &rarr;</button>
            </div>
          </div>
        </div>

        {/* Simplified details — stacked red/blue */}
        <div className="m-pt-details">
          <div className="m-pt-detail-box m-pt-detail-red" onClick={() => navigate('/purple-team#section-red-team')}>
            <h3 className="pt-details-label">Agentic Red Team</h3>
            <h4 className="pt-details-agent-heading pt-details-agent-red">Offensive Agent</h4>
            <ul className="pt-details-list">
              <li>Simulates real-world attacks</li>
              <li>Executes multi-step adversarial attack chains</li>
              <li>Uncovers vulnerabilities generic tools miss</li>
            </ul>
            <button className="pt-see-action pt-see-action-red" onClick={() => navigate('/purple-team#section-red-team')}>See it in Action &rarr;</button>
          </div>

          <div className="m-pt-shield-center">
            <div className="pt-details-shield m-pt-details-shield">
              <svg className="pt-details-shield-curved-text-top" width="220" height="60" viewBox="0 0 220 60" overflow="visible">
                <defs>
                  <path id="mCurvedTextPathTop" d="M 5,55 A 110,110 0 0,1 215,55" fill="none" />
                </defs>
                <text fill="rgba(160, 100, 255, 0.55)" fontSize="11" fontFamily="Inter, sans-serif" fontWeight="600" letterSpacing="3">
                  <textPath href="#mCurvedTextPathTop" startOffset="50%" textAnchor="middle">BLTZ PURPLE TEAM</textPath>
                </text>
              </svg>
              <svg className="pt-details-shield-orbit" width="180" height="180" viewBox="0 0 180 180">
                <defs>
                  <marker id="m-arrow-red" markerWidth="12" markerHeight="10" refX="6" refY="5" orient="auto">
                    <polygon points="12,0 0,5 12,10" fill="rgba(255, 59, 92, 0.25)" />
                  </marker>
                  <marker id="m-arrow-blue" markerWidth="12" markerHeight="10" refX="6" refY="5" orient="auto">
                    <polygon points="12,0 0,5 12,10" fill="rgba(80, 100, 255, 0.25)" />
                  </marker>
                </defs>
                <path d="M 90,3 A 87,87 0 0,0 78,176" fill="none" stroke="rgba(255, 59, 92, 0.25)" strokeWidth="1" strokeLinecap="round" markerStart="url(#m-arrow-red)" />
                <path d="M 90,177 A 87,87 0 0,0 102,4" fill="none" stroke="rgba(80, 100, 255, 0.25)" strokeWidth="1" strokeLinecap="round" markerStart="url(#m-arrow-blue)" />
              </svg>
              <img src={purpleteamImg} alt="Purple Shield" className="pt-details-shield-img" />
              <svg className="pt-details-shield-curved-text" width="220" height="60" viewBox="0 0 220 60" overflow="visible">
                <defs>
                  <path id="mCurvedTextPath" d="M 5,5 A 110,110 0 0,0 215,5" fill="none" />
                </defs>
                <text fill="rgba(255,255,255,0.55)" fontSize="11" fontFamily="Inter, sans-serif" fontWeight="600" letterSpacing="3">
                  <textPath href="#mCurvedTextPath" startOffset="50%" textAnchor="middle">CLOSED LOOP DEFENSE</textPath>
                </text>
              </svg>
            </div>
          </div>

          <div className="m-pt-detail-box m-pt-detail-blue" onClick={() => navigate('/purple-team#section-blue-team')}>
            <h3 className="pt-details-label">Agentic Blue Team</h3>
            <h4 className="pt-details-agent-heading pt-details-agent-blue">Defensive Agent</h4>
            <ul className="pt-details-list">
              <li>Detects and blocks threats in real time</li>
              <li>Automatically remediates discovered risks</li>
              <li>Removes manual fix cycles and reduces cost</li>
            </ul>
            <button className="pt-see-action pt-see-action-blue" onClick={() => navigate('/purple-team#section-blue-team')}>See it in Action &rarr;</button>
          </div>
        </div>
      </section>

      {/* ─── WORKSPACE ─── */}
      <section className="section-workspace m-section-workspace" id="workspace">
        <h2 className="workspace-title m-workspace-title">AI Governance Automation</h2>
        <p className="workspace-desc m-workspace-desc">AI governance automation platform that provides organizations with visibility, policy enforcement, automation, and compliance reporting for how employees and teams use AI tools.</p>
        <div className="workspace-product">
          <img src={blueShieldImg} alt="Blue Shield" className="workspace-shield" />
          <span className="workspace-label m-workspace-label">Bltz Workspace</span>
        </div>

        <div className="m-workspace-cards">
          <div className="m-workspace-card">
            <img src={workspaceVisibilityImg} alt="AI Asset Visibility" className="m-workspace-card-img" />
            <div className="m-workspace-card-content">
              <h3 className="workspace-card-label m-workspace-card-label">See Every AI System</h3>
              <h4 className="workspace-card-title">Agents, copilots, and shadow AI — mapped and monitored in real time.</h4>
              <button className="workspace-card-btn m-workspace-card-btn" onClick={() => navigate('/ai-governance#section-visibility')}>Learn More &rarr;</button>
            </div>
          </div>
          <div className="m-workspace-card">
            <img src={aiGovernancePolicyImg} alt="AI Governance Automation" className="m-workspace-card-img" />
            <div className="m-workspace-card-content">
              <h3 className="workspace-card-label m-workspace-card-label">Automate AI Governance</h3>
              <h4 className="workspace-card-title">Enforce policies across prompts, data, and usage — automatically.</h4>
              <button className="workspace-card-btn m-workspace-card-btn" onClick={() => navigate('/ai-governance#section-governance')}>Learn More &rarr;</button>
            </div>
          </div>
          <div className="m-workspace-card">
            <img src={isoChartImg} alt="Compliance Frameworks" className="m-workspace-card-img" />
            <div className="m-workspace-card-content">
              <h3 className="workspace-card-label m-workspace-card-label">Built for Enterprise Compliance</h3>
              <h4 className="workspace-card-title">Aligned to NIST, ISO 42001, and SOC 2 — out of the box.</h4>
              <button className="workspace-card-btn m-workspace-card-btn" onClick={() => navigate('/ai-governance#section-compliance')}>Learn More &rarr;</button>
            </div>
          </div>
          <div className="m-workspace-card">
            <img src={openclawWarningImg} alt="Block AI Tools" className="m-workspace-card-img" />
            <div className="m-workspace-card-content">
              <h3 className="workspace-card-label m-workspace-card-label">Block Unsanctioned AI Tools</h3>
              <h4 className="workspace-card-title">Detect, control, and stop unauthorized AI applications before data is exposed.</h4>
              <button className="workspace-card-btn m-workspace-card-btn" onClick={() => navigate('/ai-governance#section-shadow-ai')}>Learn More &rarr;</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MainMobile;
